import {Pipe, PipeTransform} from '@angular/core';
import {ActivityPrice} from '@domain/activity/activity.dto';

@Pipe({
  name: 'activityPrice',
  pure: true
})
export class ActivityPricePipe implements PipeTransform {

  public transform(price: ActivityPrice | null, isRecurrent: boolean, showMax = true): string {
    let str = '';
    if (!!price?.price) {
      str += `Dès ${price.price.toFixed(2)}`;
      if (isRecurrent) {
        const isPricePerSession = price?.isPricePerSession;
        if (isPricePerSession) {
          str += ' par séance';
        } else if(isPricePerSession === false) {
          str += ' pour toutes les séances';
        }
      }
    }
    if (showMax && !!price?.maxPrice) {
      str += (!!price.price ? ', max. ' : 'Max. ') + price.maxPrice.toFixed(2);
    }
    return str;
  }

}
